import styled from "styled-components"

export const StyledULItem = styled.li`
  display: flex;
  align-items: baseline;
  margin-bottom: 4px;

  :before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    background-color: ${(p) => p.theme.colors.darkGrey};
    margin-left: 10px;
    border-radius: 50%;
    flex-shrink: 0;
    position: relative;
    top: -1px;
    order: -1;
  }
  a::before {
    display: none;
  }
`
